import { render, staticRenderFns } from "./AddAdver.vue?vue&type=template&id=b938e85a&scoped=true"
import script from "./AddAdver.vue?vue&type=script&lang=js"
export * from "./AddAdver.vue?vue&type=script&lang=js"
import style0 from "./AddAdver.vue?vue&type=style&index=0&id=b938e85a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b938e85a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b938e85a')) {
      api.createRecord('b938e85a', component.options)
    } else {
      api.reload('b938e85a', component.options)
    }
    module.hot.accept("./AddAdver.vue?vue&type=template&id=b938e85a&scoped=true", function () {
      api.rerender('b938e85a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/productAppConfig/productConfig/projectManage/components/AddAdver.vue"
export default component.exports